"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _md = _interopRequireDefault(require("md5"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * settings: {
 *     buttons: [
 *         {
 *             id: 1,
 *             type: "edit",
 *             label: "",
 *             withTooltip: false,
 *             className: "btn-xs btn-primary",
 *             icon: {
 *                 name: "pencil",
 *                 paths: [
 *                     "M864 0c88.364 0 160 71.634 160 160 0 36.020-11.91 69.258-32 96l-64 64-224-224 64-64c26.742-20.090 59.978-32 96-32zM64 736l-64 288 288-64 592-592-224-224-592 592zM715.578 363.578l-448 448-55.156-55.156 448-448 55.156 55.156z"
 *                     ],
 *                 viewBox: "0 0 1024 1024"
 *             },
 *             action: {
 *                 name: "buttonEdit"
 *             }
 *         },
 *         {
 *             id: 2,
 *             type: "delete",
 *             label: "",
 *             withTooltip: false,
 *             className: "btn-xs btn-primary",
 *             icon: {
 *                 name: "bin",
 *                 paths: [
 *                     "M128 320v640c0 35.2 28.8 64 64 64h576c35.2 0 64-28.8 64-64v-640h-704zM320 896h-64v-448h64v448zM448 896h-64v-448h64v448zM576 896h-64v-448h64v448zM704 896h-64v-448h64v448z",
 *                     "M848 128h-208v-80c0-26.4-21.6-48-48-48h-224c-26.4 0-48 21.6-48 48v80h-208c-26.4 0-48 21.6-48 48v80h832v-80c0-26.4-21.6-48-48-48zM576 128h-192v-63.198h192v63.198z"
 *                 ],
 *                 viewBox: "0 0 1024 1024"
 *             },
 *             action: {
 *                 name: "buttonDelete"
 *             }
 *         },
 *         {
 *             id: 3,
 *             type: "archive",
 *             label: "",
 *             withTooltip: false,
 *             className: "btn-xs btn-primary",
 *             icon: {
 *                 name: "drawer-in",
 *                 paths: [
 *                     "M1016.988 652.010l-256-320c-11.040-13.798-31.176-16.036-44.978-4.998-13.8 11.040-16.038 31.176-4.998 44.978l248.988 311.234v20.776h-224l-128 128h-192l-128-128h-224v-20.776l248.988-311.234c11.042-13.8 8.804-33.938-4.998-44.978s-33.94-8.804-44.978 4.998l-256 320c-4.538 5.674-7.012 12.724-7.012 19.99v288c0 35.346 28.654 64 64 64h896c35.348 0 64-28.654 64-64v-288c0-7.266-2.472-14.316-7.012-19.99z",
 *                     "M512 736l224-224h-160v-320h-128v320h-160z"
 *                 ],
 *                 viewBox: "0 0 1024 1024"
 *             }
 *             action: {
 *                 name: "buttonArchive"
 *             }
 *         },
 *         ...
 *     ]
 * }
 */

/**
 * acceptable button types: ['edit', 'archive', 'delete', 'loginAs', 'changePassword']
 */

var actionType = 'rostering';
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: (0, _md["default"])(row),
      className: (0, _classnames["default"])('table-renderers-rostering-buttons', 'text-nowrap', _style["default"].rosteringButtonContainer)
    }, settings.buttons.map(function (button) {
      var buttonNode = /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        title: /*#__PURE__*/_react["default"].createElement("span", {
          className: "icon"
        }, /*#__PURE__*/_react["default"].createElement("svg", {
          width: "15",
          height: "15",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: button.icon.viewBox
        }, /*#__PURE__*/_react["default"].createElement("g", null, button.icon.paths.map(function (p) {
          return /*#__PURE__*/_react["default"].createElement("path", {
            key: p,
            d: p
          });
        }))), " ".concat(button.label)),
        className: 'btn ' + button.className,
        onClick: function onClick() {
          if (button.action) {
            callbackHandler("".concat(actionType, "::").concat(button.action.name), {
              row: row
            });
          } else {
            callbackHandler("".concat(actionType, "::").concat(button.type), {
              row: row
            });
          }
        }
      }), ' ');
      if (button.withTooltip) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          key: button.type,
          title: button.tooltipText ? button.tooltipText : button.label
        }, buttonNode);
      }
      return /*#__PURE__*/_react["default"].createElement("span", {
        key: button.type
      }, buttonNode);
    }));
  };
}; // import Renders from 'cccisd-renderers';
// export default ({ value, row }) => {
//     var one = Renders.RosteringButtons(settings, callbackHandler)(value, row);
//     return (
//         <div>
//             {one}
//             <div>some other stuff</div>
//         </div>
//     )
// }
// export default (settings, callbackHandler) => {
//     return ({ value, row }) => {
//         var one = Renders.RosteringButtons(settings, callbackHandler)(value, row);
//         return (
//             <div>
//                 {one}
//                 <div>some other stuff</div>
//             </div>
//         )
//     }
// }